export function formatBalance(balance: number): string {
  return balance ? `$${balance}` : 'N/A'
}
